document.querySelectorAll('.custom-switcher').forEach(function(switcher) {
  const toggle = switcher.querySelector('.switcher-toggle');
  const dropdown = switcher.querySelector('.switcher-dropdown');

  // Pijl toevoegen
  let arrow = document.createElement('span');
  arrow.className = 'arrow';
  arrow.innerHTML = '▼';
  toggle.appendChild(arrow);

  // Klik dropdown openen/sluiten
  toggle.addEventListener('click', function(e) {
    e.preventDefault();
    switcher.classList.toggle('open');
  });
});

// Klik buiten sluit dropdown
document.addEventListener('click', function(e) {
  document.querySelectorAll('.custom-switcher.open').forEach(function(openSwitcher) {
    if(!openSwitcher.contains(e.target)) {
      openSwitcher.classList.remove('open');
    }
  });
});

// --- Language switcher met fallback ---
document.querySelectorAll('.language-switcher a[data-lang]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    e.preventDefault();

    const lang = link.getAttribute('data-lang');
    const currentPath = window.location.pathname;
    const newPath = currentPath.replace(/^\/(en|nl|fr|de|es|it)/, '');
    const targetUrl = '/' + lang + newPath;
    const homepageFallback = '/' + lang;

    fetch(targetUrl, { method: 'HEAD' })
      .then(function(res) {
        if(res.ok) window.location.href = targetUrl;
        else window.location.href = homepageFallback;
      })
      .catch(function() {
        window.location.href = homepageFallback;
      });
  });
});

// --- Currency switcher ---
document.querySelectorAll('.currency-switcher a[data-currency]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const currency = link.getAttribute('data-currency');
    const langPrefix = window.location.pathname.split('/')[1]; // eerste segment als taal
    window.location.href = '/' + langPrefix + '?currency=' + currency;
  });
});
